import "./index.scss";
import { DS_TEMPLATE } from './constants.js'
import * as helpers from './helpers.js'

export default class dsAccessibility {
    
    constructor(args) {
        // Prevent run in Node env
        if (typeof window === 'undefined') {
            return
        }

        this.generator(args)
    }
    
    generator(customOptions) {
        let element = document.getElementsByTagName('body')[0];

        if(customOptions.wrapper)
            element = customOptions.wrapper;
    
        customOptions = customOptions || {};
    
        let defaultOptions = {
            isMenuOpened: false,
            highlightedLinks: false,
            isMobileEnabled: true,
            grayscale: 0,
            brightness: 100,
            contrast: 100,
            maxZoomLevel: 3,
            minZoomLevel: 0.5,
            zoomStep: 0.2,
            zoom: 1,
            cursor: false,
            textSelector: '.ds-accessibility-text',
            invert: false,
            localization: ['tr'],
            iconSize: 'm'
        };
    
        let userOptions = helpers.getUserOptions();
        let initialOptions = Object.assign({}, defaultOptions, customOptions);
        let options = Object.assign({}, initialOptions, userOptions, customOptions);
    
        if (!options.isMobileEnabled && helpers.isMobileBrowser()) {
            console.log('disabling accessibility plugin due to mobile browser');
            return;
        }
    
        element.innerHTML += DS_TEMPLATE;
    
        let html = document.getElementsByTagName('html')[0];
        let body = document.getElementsByTagName('body')[0];
        let container = document.getElementsByClassName("ds-accessibility")[0];
        let menu = document.getElementsByClassName("ds-accessibility-menu")[0];
        let expandButton = document.getElementsByClassName("ds-accessibility-expand-button")[0];
        let closeButton = document.getElementsByClassName("ds-accessibility-close-button")[0];
        let invertButton = document.getElementsByClassName("ds-accessibility-invert-button")[0];
        let cursorButton = document.getElementsByClassName("ds-accessibility-cursor-button")[0];
        let zoomInButton = document.getElementsByClassName("ds-accessibility-zoom-in-button")[0];
        let zoomOutButton = document.getElementsByClassName("ds-accessibility-zoom-out-button")[0];
        let brightnessButton = document.getElementsByClassName("ds-accessibility-brightness-button")[0];
        let monochromeButton = document.getElementsByClassName("ds-accessibility-monochrome-button")[0];
        let contrastButton = document.getElementsByClassName("ds-accessibility-contrast-button")[0];
        let resetButton = document.getElementsByClassName("ds-accessibility-reset-button")[0];
        let cursorWorkaround = document.getElementsByClassName("ds-accessibility-cursor-workaround")[0];
    
        container.classList.add(helpers.getIconClass(options.iconSize));
    
        let languages = helpers.getLanguages(options.localization, options.localizationMap);
        helpers.translateTheme(languages[Object.keys(languages)[0]]);
    
        html.classList.add("ds-accessibility-zoom");
    
        brightnessButton.addEventListener('click', (event) => {
            options.brightness += 50;
    
            if (options.brightness > 150) {
                options.brightness = 50;
            }
    
            apply();
        });
    
        contrastButton.addEventListener('click', (event) => {
            options.contrast += 50;
    
            if (options.contrast > 150) {
                options.contrast = 50;
            }
    
            apply();
        });
    
        monochromeButton.addEventListener('click', (event) => {
            options.grayscale += 100;
            if (options.grayscale > 100) {
                options.grayscale = 0;
            }
            apply();
        });
    
        resetButton.addEventListener('click', (event) => {
            options = Object.assign({}, initialOptions);
            options.isMenuOpened = false;
    
            apply();
        });
    
        zoomInButton.addEventListener('click', (event) => {
            options.zoom = Math.min(options.maxZoomLevel, options.zoom + options.zoomStep);
            apply();
        });
    
        zoomOutButton.addEventListener('click', (event) => {
            options.zoom = Math.max(options.minZoomLevel, options.zoom - options.zoomStep);
            apply();
        });
    
        invertButton.addEventListener('click', (event) => {
            options.invert = !options.invert;
            apply();
        });
    
        cursorButton.addEventListener('click', (event) => {
            options.cursor = !options.cursor;
            apply();
        });
    
        expandButton.addEventListener('click', (event) => {
            options.isMenuOpened = true;
            apply();
        });
    
        closeButton.addEventListener('click', (event) => {
            options.isMenuOpened = false;
            apply();
        });
    
        document.addEventListener('click', (event) => {
            console.log(event.target)
    
            if (event.target.closest('.ds-accessibility') && !event.target.closest('.ds-accessibility').length) {
                if (options.isMenuOpened) {
                    options.isMenuOpened = false;
                    apply();
                }
            }
        });
    
        expandButton.style.display = "none";
        menu.style.display = "none";
    
        if (customOptions.isMenuOpened) {
            options.isMenuOpened = true;
            menu.style.display = "";
            expandButton.style.display = "none";
        }
        else {
            options.isMenuOpened = false;
        }
    
        cursorWorkaround.style.display = "none";
    
        let googleChrome = helpers.isGoogleChrome();
        if (!googleChrome) {
    
            document.addEventListener('mousemove', (e) => {
    
                if (!options.cursor) {
                    return;
                }
    
                cursorWorkaround.style['left'] = e.pageX / options.zoom;
                cursorWorkaround.style['top'] = e.pageY / options.zoom;
            });
        }
    
    
        helpers.applyTextZoom(options.textSelector, 1);
    
        apply();
    
        function apply() {
            if (options.isMenuOpened) {
                helpers.fadeOut(expandButton);
                helpers.fadeIn(menu);
    
                container.classList.remove("ds-accessibility-collapsed");
                container.classList.add("ds-accessibility-expanded");
            }
            else {
                helpers.fadeIn(expandButton);
                helpers.fadeOut(menu);
    
                container.classList.remove("ds-accessibility-expanded");
                container.classList.add("ds-accessibility-collapsed");
            }
    
    
            let filters = [];
            if (options.invert) {
                filters.push('invert(1)');
            }
    
            filters.push('contrast(' + options.contrast + '%)');
            filters.push('brightness(' + options.brightness + '%)');
            filters.push('grayscale(' + options.grayscale + '%)');
            let filterValue = filters.join(' ');
            html.style['filter'] = filterValue;
    
            helpers.applyTextZoom(options.textSelector, options.zoom);
    
            if (options.cursor) {
                html.classList.add("ds-accessibility-cursor");
    
                if (!googleChrome) {
                    cursorWorkaround.style.display = "";
                }
            }
            else {
                html.classList.remove("ds-accessibility-cursor");
                if (!googleChrome) {
    
                    cursorWorkaround.style.display = "none";
                }
            }
    
            helpers.setUserOptions(options);
        }
    }
}


/*
export default class dsAccessibility {
    
    constructor(args) {
        alert('test')
        // Prevent run in Node env
        if (typeof window === 'undefined') {
            return
        }

        helpers.generator(args)
    }
}
*/